import Model from "./abstract/Model";

export default class ContractCustomerSignOff extends Model {
  is_fully_refueled;
  contract_id;
  address_return;
  mileage;

  constructor(props) {
    super();

    this.initializeAttributes(props, {});
  }
}
